'use client';

import React, { createContext, useContext } from 'react';

import type { Prisma } from '@prisma/client';

export type Tenant = Prisma.TenantGetPayload<{
  select: {
    name: true;
    subdomain: true;
    baseTheme: true;
  };
}>;

const TenantContext = createContext<Tenant | null>(null);

export const useTenant = () => useContext(TenantContext);

export const TenantProvider = ({
  tenant,
  children,
}: {
  tenant: Tenant | null;
  children: React.ReactNode;
}) => (
  <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
);
